import { createSelector } from 'reselect';
import getIsFieldVisionSupported from '../helpers/isFieldVisionSupported';
import getQueryParamOverride from '@gameday/utils/getQueryParamOverride';

const useContentEpgOverride = getQueryParamOverride('useContentEpg');

const getAbstractGameState = (state) => state.gumbo?.gameData?.status?.abstractGameState;
const getGamePk = (state) => state.gumbo?.gamePk;
const getConfig = (state) => state.config;
const getLanguage = (state) => getConfig(state)?.language;
const getForcedFieldVisionOn = (state) => getConfig(state).forceFieldVisionOn;
const getFieldVisionOn = (state) => state.views?.fieldVisionOn;
const getIsLoading = (state) => state.loading?.isLoading;
const getAccessToken = (state) => state.userinfo?.accessToken;
const getIsLoggedIn = (state) => state.loggedIn?.isLoggedIn;
const getBatEnabled = (state) => getConfig(state).batEnabled;
const getUseFallbackFV = (state) => getConfig(state).useFallbackFV;;
const getFreeGameOfTheDay = (state) => (useContentEpgOverride ?? getConfig(state)?.useContentEpg)
    ? state.schedule?.contentMediaLinks?.tv?.list?.[0]?.freeGame
    : state.schedule?.mediaLinks?.tv?.list?.[0]?.freeGame;
const getFieldVisionLiveFreeGameOnly = (state) => getConfig(state)?.fieldVisionLiveFreeGameOnly;
const getFieldVisionLoggedInOnly = (state) => getConfig(state)?.blockLoginActivities;

export const getFieldVisionState = createSelector(
    [
        getForcedFieldVisionOn,
        getFieldVisionOn,
        getLanguage,
        getIsLoading,
        getIsLoggedIn,
        getAbstractGameState,
        getGamePk,
        getAccessToken,
        getFreeGameOfTheDay,
        getIsFieldVisionSupported,
        getFieldVisionLiveFreeGameOnly,
        getFieldVisionLoggedInOnly
    ],
    (
        forcedFieldVisionOn,
        fieldVisionOn,
        language,
        isLoading,
        isLoggedIn,
        gameState,
        gamePk,
        accessToken,
        freeGameOfTheDay,
        isFieldVisionSupported,
        fieldVisionLiveFreeGameOnly,
        fieldVisionLoggedInOnly
    ) => ({
        enableFieldVision: isFieldVisionSupported,
        forcedFieldVisionOn,
        fieldVisionOn,
        language,
        isLoading,
        isLoggedIn,
        gameState,
        gamePk,
        accessToken,
        freeGameOfTheDay,
        isFieldVisionSupported,
        fieldVisionLiveFreeGameOnly,
        fieldVisionLoggedInOnly
    })
);

export const getFVRuntimeState = createSelector(
    [getUseFallbackFV, getBatEnabled],
    (useFallbackFV, batEnabled) => ({
        useFallbackFV,
        batEnabled
    })
);
